import React, { createContext, useState, useContext, ReactNode } from "react";

// Define a type for the page
interface Page {
  id: number;
  title: string;
  page_id: string;
  children?: Page[];
}

// Define a type for the context value
interface PageContextType {
  selectedPage: Page | null;
  setSelectedPage: (page: Page) => void;
}

// Create the context with a default value of null
const PageContext = createContext<PageContextType | undefined>(undefined);

// Create a provider component
export const PageProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [selectedPage, setSelectedPage] = useState<Page | null>(null);

  return (
    <PageContext.Provider value={{ selectedPage, setSelectedPage }}>
      {children}
    </PageContext.Provider>
  );
};

// Custom hook to use the PageContext
export const usePage = (): PageContextType => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error("usePage must be used within a PageProvider");
  }
  return context;
};
